/**
 * Markering in de hele winkel.
 * 1. Zet tekst tussen [[ en ]] om naar <span class="dw-mark"> (ook in teksten uit metavelden, metaobjecten,
 *    productbeschrijvingen en standaardsecties). Secties die snippets/dw-mark.liquid gebruiken, leveren de span al.
 *    Enkele haken blijven staan. [[ en ]] moeten in hetzelfde stuk opmaak staan.
 * 2. Tekent de vorm uit Thema-instellingen > De Wijntoren > Markeerstijl (data-style op dit script):
 *    stift (balk achter de tekst) of een getekende lijn: krul, golf, dubbel, lijn, cirkel.
 * 3. Zet .is-marked zodra de markering grotendeels in beeld is; de CSS tekent dan de vorm.
 * Bij 'minder beweging' staat de markering er meteen. Overslaan kan met data-no-mark op een element.
 */
(() => {
  const STYLE = document.currentScript?.dataset.style || 'stift';
  const PATTERN = /\[\[([^\[\]\n]{1,120})\]\]/g;
  const SKIP = 'script, style, noscript, textarea, input, select, option, code, pre, svg, template, [contenteditable], [data-no-mark], .dw-mark';
  const SHAPES = {
    krul: { viewBox: '0 0 100 12', d: 'M2 9 C 20 4, 45 2.5, 70 4.5 S 94 9.5, 98 4' },
    golf: { viewBox: '0 0 100 12', d: 'M2 7 Q 8 2 14 7 T 26 7 T 38 7 T 50 7 T 62 7 T 74 7 T 86 7 T 98 7' },
    dubbel: { viewBox: '0 0 100 12', d: 'M2 5 C 30 2.5, 70 2.5, 98 4.5 M8 10 C 35 7.5, 65 7.5, 92 9' },
    lijn: { viewBox: '0 0 100 12', d: 'M2 6 L 98 6' },
    cirkel: {
      viewBox: '0 0 100 36',
      d: 'M30 4 C 60 0, 97 5, 97 18 C 97 30, 62 35, 38 33 C 14 31, 2 24, 4 15 C 6 7, 22 3, 42 3',
    },
  };

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const observer =
    !reduce && 'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-marked');
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.8, rootMargin: '0px 0px -10% 0px' }
        )
      : null;

  const wrapBrackets = (root) => {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => {
        if (!node.nodeValue.includes('[[')) return NodeFilter.FILTER_REJECT;
        return node.parentElement && !node.parentElement.closest(SKIP) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      },
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach((node) => {
      const text = node.nodeValue;
      const matches = [...text.matchAll(PATTERN)];
      if (!matches.length) return;
      const fragment = document.createDocumentFragment();
      let last = 0;
      for (const match of matches) {
        fragment.append(text.slice(last, match.index));
        const mark = document.createElement('span');
        mark.className = 'dw-mark';
        mark.textContent = match[1];
        fragment.append(mark);
        last = match.index + match[0].length;
      }
      fragment.append(text.slice(last));
      node.replaceWith(fragment);
    });
  };

  const addShape = (mark) => {
    const shape = SHAPES[STYLE];
    if (!shape || mark.querySelector('.dw-mark__svg')) return;
    mark.classList.add('dw-mark--svg', `dw-mark--${STYLE}`);
    mark.insertAdjacentHTML(
      'beforeend',
      `<svg class="dw-mark__svg" viewBox="${shape.viewBox}" preserveAspectRatio="none" aria-hidden="true" focusable="false"><path d="${shape.d}" pathLength="1"/></svg>`
    );
  };

  const scan = (root = document.body) => {
    wrapBrackets(root);
    root.querySelectorAll('.dw-mark:not(.is-marked)').forEach((mark) => {
      addShape(mark);
      if (observer) observer.observe(mark);
      else mark.classList.add('is-marked');
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan());
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
